module.exports = __webpack_public_path__ + "site/img/17.841fafb3.jpg";